import { activeEnv } from '../../../build-scripts/environment';

export const isMeridianRedesignEnabled = (): boolean => {
  switch (activeEnv) {
    case 'development':
    case 'staging':
    case 'test':
      return true;
    case 'uat':
    case 'preprod':
    case 'prod':
    default:
      return false;
  }
};
